import "./WhiteBox.css";

const WhiteBox = (props: { className?: string; children?: any }) => (
  <div className={`WhiteBox ${props.className || ""}`}>{props.children}</div>
);

export default WhiteBox;
